export default {
  title: 'Solicitar factura',
  form: {
    is_receipt_required: {
      label: 'Solicitar factura por email',
    },
    company_name: {
      placeholder: 'Nombre de empresa (opcional)',
    },
    first_name: {
      placeholder: 'Nombre',
    },
    last_name: {
      placeholder: 'Apellidos',
    },
    address: {
      placeholder: 'Calle y número',
    },
    zip_code: {
      placeholder: 'Código postal',
    },
    city: {
      placeholder: 'Ciudad',
    },
    tax_id: {
      placeholder: 'NIF/CIF',
    },
    email: {
      placeholder: 'Correo electrónico',
    },
  },
};
